export const initGeoControlSection = () => {
  const sections = [...document.querySelectorAll('[data-geo-section]')];
  if (!sections.length) return;

  sections.forEach((section) => {
    const trigger = section.querySelector('[data-geo-section-trigger]');

    trigger.addEventListener('click', () => {
      section.classList.toggle('-active');
    });
  });
};
